<template>
  <div class="registers">
    <div class="swiper"><img src="../img/login_bg.png" alt="" /></div>
    <!-- 手机注册 -->
    <div class="logins">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="手机注册" name="first">
          <div class="inputs">
            <el-input
              autocomplete="off"
              v-model="phonename"
              type="text"
              @input="pname"
              prefix-icon="el-icon-user"
              placeholder="请输入姓名"
            ></el-input>
            <el-input
              autocomplete="off"
              v-model="phonenumber"
              @input="pnumber"
              maxlength="11"
              placeholder="手机号"
              prefix-icon="el-icon-phone-outline"
            ></el-input>
            <div class="verify">
              <el-input
                autocomplete="off"
                style="margin-top: 0px"
                @input="pcode"
                placeholder="请输入验证码"
                prefix-icon="el-icon-key"
                v-model="phonecode"
              ></el-input>
              <div
                @click.stop="sendSmsCode"
                class="zai-checking"
                v-if="state === false"
              >
                获取验证码
              </div>
              <div class="zai-checking zai-time" v-if="state === true">
                倒计时{{ currentTime }}s
              </div>
            </div>
            <!-- <el-input
              autocomplete="off"
              placeholder="请输入密码"
              @input="ppassword"
              show-password
              prefix-icon="el-icon-lock"
              v-model="phonepassword"
            ></el-input> -->
          </div>

          <!-- <div class="guide">
            <el-checkbox @change="guides" v-model="checked"></el-checkbox>
            我同意
            <span @click.stop="fu">《使用条款》</span>
          </div> -->
          <div @click="sub" class="register">提交</div>
          <div @click.stop="login()" class="zhu">账号登录</div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<style lang="scss">
.registers {
  min-width: 1200px;
  position: relative;
  // background: rgba(245, 247, 250, 1);
  .swiper {
    height: 650px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .logins {
    width: 358px;
    // height: 550px;
    padding-top: 17px;
    box-sizing: border-box;
    position: absolute;
    right: 20%;
    top: 50%;
    margin-top: -275px;
    background: #ffffff;
    z-index: 1;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    .find {
      text-align: center;
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(54, 64, 94, 1);
    }
    .el-tabs__nav-scroll {
      display: flex;
      margin-left: 50px;
    }
    .el-tabs__item {
      padding: 0 65px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
    }
    .is-active {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #0f77bf;
    }
    .el-tabs__nav-wrap::after {
      background-color: #ffffff;
    }
    .inputs {
      width: 306px;
      margin: 10px auto 30px auto;
      .el-input__inner {
        border: none;
        border-radius: 0px;
        border-bottom: 1px solid #e6e6e6;
      }
      .el-input {
        margin-top: 30px;
      }
    }
    .forget {
      width: 306px;
      margin: 18px auto 40px auto;
      text-align: right;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
      cursor: pointer;
    }
    .guide {
      width: 306px;
      margin: 0px auto 9px auto;
      color: rgba(25, 141, 255, 1);
      font-size: 14px;
      font-family: MicrosoftYaHei;
      span {
        cursor: pointer;
        color: rgba(25, 141, 255, 1);
      }
      .el-radio__label {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 153, 153, 1);
      }
    }
    .register {
      width: 306px;
      height: 44px;
      margin: 0 auto;
      background: rgba(15, 119, 191, 1);
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      text-align: center;
      cursor: pointer;
    }
    .zhu {
      cursor: pointer;
      width: 80px;
      height: 44px;
      margin: 19px auto 10px auto;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(25, 141, 255, 1);
      line-height: 44px;
      text-align: center;
    }
    .zhu:hover {
      color: red;
    }
    .verify {
      height: 40px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      .el-input__inner {
        width: 60%;
      }
      .zai-checking {
        height: 40px;
        width: 40%;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        color: #0f75bd;
        cursor: pointer;
      }
    }
  }
}
</style>

<script>
import {
  getcodes,
  phoneregister,

} from "../api.js";
export default {
  name: "Register",
  components: {},
  data() {
    return {
      fetch_static: false,
      fetch_statics: false, //邮箱
      activeName: "first",
      phonename: "", //手机注册姓名
      phonenumber: "", //手机注册手机号
      phonecode: "", //手机注册验证码
      phonepassword: "", //手机注册密码
      emailname: "", //邮箱注册姓名
      emailnumber: "", //邮箱地址
      emailcode: "", //邮箱验证码
      emailpassword: "", //邮箱注册密码
      input2: "",
      checked: true,
      echecked: true,
      state: false, //是否开启倒计时
      totalTime: 120, //总时间，单位秒
      recordingTime: 0, //记录时间变量
      currentTime: 0, //显示时间变量
      states: false, //是否开启倒计时
      totalTimes: 60, //总时间，单位秒
      recordingTimes: 0, //记录时间变量
      currentTimes: 0, //显示时间变量
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    login() {
      this.$router.push("/Login");
    },
    //手机注册获取姓名
    pname(e) {
      this.phonename = e;
      this.fetch_static = false;
    },

    //手机注册获取手机号
    pnumber(e) {
      this.phonenumber = e;
      this.fetch_static = false;
    },

    // 手机注册获取验证码
    pcode(e) {
      this.phonehonecode = e;
      this.fetch_static = false;
    },
    // 邮箱验证码
    ecode(e) {
      this.emailcode = e;
      this.fetch_statics = false;
    },
    //手机注册密码
    ppassword(e) {
      this.phonepassword = e;
      this.fetch_static = false;
    },
    // 邮箱注册密码
    epassword(e) {
      this.emailpassword = e;
      this.fetch_statics = false;
    },
    // 手机注册条款
    guides(e) {
      this.checked = e;
      this.fetch_static = false;
    },

    // 手机号几时
    checkingTime() {
      let that = this;
      //判断是否开启
      if (this.state) {
        //判断显示时间是否已到0，判断记录时间是否已到总时间
        if (this.currentTime > 0 && this.recordingTime <= this.totalTime) {
          //记录时间增加 1
          this.recordingTime = this.recordingTime + 1;
          //显示时间，用总时间 - 记录时间
          this.currentTime = this.totalTime - this.recordingTime;
          //1秒钟后，再次执行本方法
          setTimeout(() => {
            //定时器内，this指向外部，找不到vue的方法，所以，需要用that变量。
            that.checkingTime();
          }, 1000);
        } else {
          //时间已完成，还原相关变量
          this.state = false; //关闭倒计时
          this.recordingTime = 0; //记录时间为0
          this.currentTime = this.totalTime; //显示时间为总时间
        }
      } else {
        //倒计时未开启，初始化默认变量
        this.state = false;
        this.recordingTime = 0;
        this.currentTime = this.totalTime;
      }
    },

    // 手机短信验证码
    sendSmsCode() {
      let that = this;
      let phone = that.phonenumber;
      var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
      if (phone.length < 1) {
        that.$message.error("手机号不能为空哦！");
        return;
      } else if (!reg.test(phone)) {
        that.$message.error("手机格式不正确！");
        return;
      }
      let phones = { Phone: phone, Source: "pc" ,Type:'2'};
      getcodes(phones).then((res) => {
        if (res.data.Code == 0) {
          that.$message({
            message: res.data.Data,
            type: "success",
          });
          // 把显示时间设为总时间
          that.currentTime = that.totalTime;
          //开始倒计时
          that.state = true;
          //执行倒计时
          that.checkingTime();
        } else {
          that.$message.error(res.data.Message);
        }
      });
    },

    // 提交手机注册
    sub() {
      let that = this;
      let phonename = that.phonename;
      let phonenumber = that.phonenumber;
      let phonehonecode = that.phonehonecode;
      let phonepassword = that.phonepassword;
      if (phonename == "") {
        that.$message.error("请填写姓名");
        return;
      }
      if (phonenumber == "") {
        that.$message.error("请填写手机号");
        return;
      }
      if (phonehonecode == "") {
        that.$message.error("请填写验证码");
        return;
      }
      // if (phonepassword == "") {
      //   that.$message.error("请填写密码");
      //   return;
      // }

      // if (/[\u4E00-\u9FA5]/g.test(phonepassword)) {
      //   that.$message.error("密码不能有汉字");
      //   return;
      // }

      if (!that.checked) {
        that.$message.error("请勾选服务条款");
        return;
      }

      let datas = {
        Source: "web",
    
        Phone: phonenumber,
        Code: phonehonecode,
        NickName: phonename,
        Password: phonepassword,
        //  Type: "2",
      };
      phoneregister(datas)
        .then((res) => {
          if (res.data.Code == 0) {
            that.fetch_static = true;
            localStorage.setItem("AccessToken", res.data.Data.AccessToken);
            localStorage.setItem("RefreshToken", res.data.Data.RefreshToken);
            localStorage.setItem(
              "AccessTokenTime",
              res.data.Data.AccessTokenTime
            );
            localStorage.setItem(
              "RefreshTokenTime",
              res.data.Data.RefreshTokenTime
            );
            localStorage.setItem("phonenumber", phonenumber);
            localStorage.setItem("password", phonepassword);
            localStorage.setItem("username", res.data.Data.MemberName);
            that.$message({
              message: "注册成功",
              type: "success",
            });

            setTimeout(() => {
              that.$router.push("/");
              // that.$router.push('/Login');
            }, 500);
          } else {
            that.$message.error(res.data.Message);
            that.fetch_static = false;
          }
        })
        .catch((error) => {
          console.log(error);
          that.fetch_static = false;
        });
    },
  },
};
</script>
